import * as ko from "knockout";
import {TBaseOrObservableType} from "../../index";
import filterHtml from './filter.html?raw';

export let template = filterHtml;

interface IParams {
    toggle: TBaseOrObservableType<boolean>
}

export class viewModel {
    private readonly toggle: TBaseOrObservableType<boolean>;

    constructor(params: IParams) {
        this.toggle = params.toggle;
    }

    private isFiltered = ko.pureComputed((): boolean => {
        if (ko.isComputed(this.toggle) || ko.isObservable(this.toggle)) {
            return !!this.toggle();
        }
        return !!this.toggle;
    });

    private getIcon() {
        if (this.isFiltered()) {
            return `fa-filter fas filter-active`;
        } else {
            return `fa-filter`;
        }
    };
}
